import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import i18n from '../../../../../translations/strings';
import EditText from '../../../../base/edit-text/edit-text';
import Button from '../../../../base/button/button';
import { EdiTextVariant } from '../../../../base/edit-text/constants';
import {
  ReservationSummaryStyled,
  sxListReservationSummary,
} from './reservation-summary.styled';
import { MakeReservationVariant } from '../../make-reservation.constants';
import ReservationSummaryRow from './components/reservation-summary-row';
import { ButtonVariant } from '../../../../base/button/constants';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface ResumeReservationProps {
  isVisible: boolean;
  sendBooking: (data: any) => void;
  onClose: () => void;
  reservations: any;
  rooms: any;
  variant: MakeReservationVariant;
  onDeleteEvent: (event: any) => void
}

const ReservationSummary = (props: ResumeReservationProps) => {
  const [notes, setNotes] = useState('');

  const [resume, setResume] = useState<any>(null);

  const adminHandleReservationMode =
    props.variant === MakeReservationVariant.AdminHandleReservation;

  useEffect(() => {
    if (props.reservations) {
      setResume({
        customerEvents: props.reservations,
        notes: notes,
      });
    }
  }, [notes, props.reservations]);

  const eventNum = props.reservations.length;

  return (
    <Modal open={props.isVisible} onClose={props.onClose}>
      <ReservationSummaryStyled.Container minHeight={props.reservations.length > 0 ? '400px' : '200px'}>
        <ReservationSummaryStyled.ContainerCloseIcon>
          <CloseIcon
            fontSize="small"
            onClick={props.onClose}
            sx={{
              cursor: 'pointer',
            }}
          />
        </ReservationSummaryStyled.ContainerCloseIcon>
        <ReservationSummaryStyled.ContainerContent>
          <ReservationSummaryStyled.Title>
            {i18n.t('booking.resumeReservation')}
          </ReservationSummaryStyled.Title>
          {props.reservations.length > 0 ?
            <ReservationSummaryStyled.SubTitle>
              {i18n.t('booking.events', { eventNum: eventNum })}
            </ReservationSummaryStyled.SubTitle> : (
              <ReservationSummaryStyled.SubTitle> {i18n.t('handleReservation.reservationSummaryDescriptionAlert')}</ReservationSummaryStyled.SubTitle>
            )
          }

          {props.reservations.length > 0 && (
            <ReservationSummaryRow
              reservations={props.reservations}
              rooms={props.rooms}
              onDeleteEvent={event => props.onDeleteEvent(event)}
            />
          )}

          {!adminHandleReservationMode && (
            <ReservationSummaryStyled.ContainerNotes>
              <EditText
                variant={EdiTextVariant.Standard}
                placeholder={i18n.t('booking.notes')}
                onChange={(value: any) => setNotes(value.target.value)}
                label={i18n.t('booking.notes')}
                multiline
              />
            </ReservationSummaryStyled.ContainerNotes>
          )}
        </ReservationSummaryStyled.ContainerContent>
        <Box sx={sxListReservationSummary.containerButton}>
          <Box sx={sxListReservationSummary.containerButtonLeft}>
            <Button
              variant={ButtonVariant.Outlined}
              onClick={props.onClose}
              label={i18n.t('common.cancel')}
            />
          </Box>
          <Box sx={sxListReservationSummary.containerButtonRight}>
            <Button
              onClick={() => props.sendBooking(resume)}
              label={
                adminHandleReservationMode
                  ? i18n.t('booking.sendUpdates')
                  : i18n.t('booking.sendReservation')
              }
            />
          </Box>
        </Box>
      </ReservationSummaryStyled.Container>
    </Modal>
  );
};

export default React.memo(ReservationSummary);
